/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>本月入账</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
          <div class="block">
            <el-date-picker
              size="small"
              style="width: 240px"
              v-model="formInline.revenueDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.roomNo" clearable placeholder="请输入房号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-form-item label="" prop="transType">
          <el-select size="small" v-model="formInline.transType" clearable placeholder="请选择类型">
            <el-option v-for="type in transTypeEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canEntry()" @click="handleEdit()">补账</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="revenueDate" label="日期" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.revenueDate|formatDate}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="roomNo" label="房号" width="80" show-overflow-tooltip :formatter="row => row.roomNo || '-'">
      </el-table-column>
      <el-table-column sortable prop="transType" label="类型" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{transTypeFormate(scope.row.transType)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="roomCost" label="房租" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="periodValidity" label="时长" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{periodValidityFormate(scope.row.periodValidity)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="depositCost" label="押金" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="networkCost" label="网费" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="sanitationCost" label="卫生费" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="waterCost" label="水费" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="otherCost" label="其他" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="totalCost" label="合计收入" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" v-if="$canManage()" @click="handleEdit(scope.$index, scope.row)">调账</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="deleteRevenueFlow(scope.$index, scope.row)">除账</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="日期">
              <div class="block" >
                <el-date-picker
                  size="small"
                  style="width: 180px"
                  v-model="editForm.revenueDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="房号">
              <el-input size="small" :style="{ width: '182px' }" tabindex="1" v-model="editForm.roomNo"  placeholder="请输入房号" v-bind:disabled=roomNoDisable></el-input>
            </el-form-item>
            <el-form-item label="房租" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="2" v-model="editForm.roomCost" @change="changeCost" placeholder="请求输入房租收入"></el-input>
            </el-form-item>
            <el-form-item label="网费" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="4" v-model="editForm.networkCost" @change="changeCost"  placeholder="请求输入房租收入"></el-input>
            </el-form-item>
            <el-form-item label="水费" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="6" v-model="editForm.waterCost" @change="changeCost"  placeholder="请求输入水费收入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时长(月)">
              <el-select size="small" v-model="editForm.periodValidity" clearable placeholder="请选择时长" v-bind:disabled=periodValidityDisable>
                <el-option v-for="type in periodValidityEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型">
              <el-select size="small" v-model="editForm.transType" clearable placeholder="请选择类型" v-bind:disabled=transTypeDisable>
                <el-option v-for="type in transTypeEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="押金" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="3" v-model="editForm.depositCost" @change="changeCost"  placeholder="请输入押金收入"></el-input>
            </el-form-item>
            <el-form-item label="卫生费" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="5" v-model="editForm.sanitationCost" @change="changeCost"  placeholder="请输入押金收入"></el-input>
            </el-form-item>
            <el-form-item label="其他" >
              <el-input size="small" :style="{ width: '182px' }" tabindex="7" v-model="editForm.otherCost" @change="changeCost"  placeholder="请输入其他收入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="费用合计">
          <el-input size="small" v-model="editForm.totalCost" auto-complete="off" placeholder="0" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {queryRevenueFlowPage, addRevenueFlowPage, deleteRevenue} from '../../api/realTimeBill'
import {formatDate} from '../../utils/util'
import Pagination from '../../components/Pagination'


export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      roomNoDisable: true,
      periodValidityDisable: true,
      transTypeDisable: true,
      title: '预览',
      transTypeEnum:[
        { key: '请选择', value: null},
        { key: '新住', value: 1},
        { key: '续费', value: 2},
        { key: '其他', value: 3},
      ],
      periodValidityEnum:[
        { key: '一周', value: 0.25},
        { key: '半月', value: 0.5},
        { key: '一月', value: 1},
        { key: '两月', value: 2},
        { key: '一季度', value: 3},
        { key: '半年', value: 6},
        { key: '一年', value: 12},
      ],
      editForm: {
        transId: '',
        revenueDate: "",
        depositCost: "",
        networkCost: "",
        otherCost: "",
        roomCost: "",
        roomNo: '',
        sanitationCost: "",
        periodValidity: "",
        totalCost: "",
        transType: '',
        waterCost: "",
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        current: 1,
        size: 10,
        revenueDate: null,
        roomNo: '',
        transType: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryRevenueFlowPage(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = this.formInline.current
            this.pageparm.pageSize = this.formInline.size
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('本月入账加载失败，请稍后再试！')
        })
    },
    data() {
      return {
        listItems: ['Item 1', 'Item 2', 'Item 3'],
      };
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '调账'
        this.editForm.depositCost=row.depositCost
        this.editForm.networkCost = row.networkCost
        this.editForm.otherCost = row.otherCost
        this.editForm.periodValidity = row.periodValidity
        this.editForm.revenueDate = formatDate(row.revenueDate)
        this.editForm.roomCost = row.roomCost
        this.editForm.roomNo = row.roomNo
        this.editForm.sanitationCost = row.sanitationCost
        this.editForm.totalCost=row.totalCost
        this.editForm.transId=row.transId
        this.editForm.transType=row.transType
        this.editForm.waterCost=row.waterCost
        this.roomNoDisable= true
        this.periodValidityDisable= true
        this.transTypeDisable=true
      } else {
        this.title = '补账'
        this.editForm.depositCost=0
        this.editForm.networkCost = 0
        this.editForm.otherCost = 0
        this.editForm.periodValidity = 1
        this.editForm.revenueDate = formatDate(new Date)
        this.editForm.roomCost = 0
        this.editForm.roomNo = ""
        this.editForm.sanitationCost = 0
        this.editForm.totalCost=0
        this.editForm.transId=""
        this.editForm.transType=""
        this.editForm.waterCost=0
        this.roomNoDisable= false
        this.periodValidityDisable= false
        this.transTypeDisable=false
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addRevenueFlowPage(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '处理成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('处理失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteRevenueFlow(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteRevenue([row.transId])
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '账务已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('账务删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    transTypeFormate(itemValue){
      for(let obj of this.transTypeEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    // 时长数据转换
    periodValidityFormate(itemValue){
      for(let obj of this.periodValidityEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
      return itemValue;
    },
    // 变动数额计算合计数额
    changeCost(){
      let editForm = this.editForm;
      editForm.totalCost=Number(editForm.depositCost)+Number(editForm.networkCost)+Number(editForm.otherCost)
        +Number(editForm.roomCost)+Number(editForm.sanitationCost)+Number(editForm.waterCost);
    }
  }
}

</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/realTimeBill/revenueFlow.vue